var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('campaign-list',{attrs:{"scope":"company"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }